
export default {
  data () {
    return { isOpen: false }
  },
  computed: {
    maxWidth () {
      return this.$vuetify.breakpoint.mobile ? '80vw' : '440px'
    }
  },
  resolveConfirmation: null,
  methods: {
    requestConfirmation () {
      console.log('Requesting attribute confirmation dialog')
      this.isOpen = true

      return new Promise((resolve) => {
        this.$options.resolveConfirmation = resolve
      })
    },
    close (confirmation) {
      this.$options.resolveConfirmation(confirmation)
      this.$options.resolveConfirmation = null
      this.isOpen = false
    }
  }
}
